export default __webpack_public_path__ + "static/media/code.69db5f65.mp3";